module.exports = __webpack_public_path__ + "media/video.fda5abf4.mp4";